// extracted by mini-css-extract-plugin
export var messageSideLeft = "_mw-1";
export var stateContainer = "_mw-0";